module.exports = __webpack_public_path__ + "static/img/no_class.872280e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no_class.svg
// module id = 829
// module chunks = 1